export default __webpack_public_path__ + "static/media/blog17.69ba3264.jpg";